import { useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { rage, useObservable } from '~/rage';
import { IHudTaskProgress } from '~/shared';
import { Quest } from '../Quest';
import { StyledContainer } from './Quests.styled';

const Quests: React.FC = () => {
	const questHudTask = useObservable(rage.quests.getHudTask());
	const dailyHudTask = useObservable(rage.dailyTasks.getHudTask());

	const allQuests = useMemo(
		() =>
			[questHudTask, dailyHudTask].filter(
				(e) => e !== null,
			) as IHudTaskProgress[],
		[questHudTask, dailyHudTask],
	);

	return (
		<StyledContainer>
			{allQuests.map((quest, index) => (
				<CSSTransition
					classNames={'quest'}
					timeout={500}
					key={index}
					unmountOnExit
					appear
				>
					<Quest {...quest} />
				</CSSTransition>
			))}
		</StyledContainer>
	);
};

export { Quests };
